import { render, staticRenderFns } from "./DiagnosticoSocioambiental.vue?vue&type=template&id=a68a1aac&lang=pug"
import script from "./DiagnosticoSocioambiental.vue?vue&type=script&lang=js"
export * from "./DiagnosticoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoSocioambiental.vue?vue&type=style&index=0&id=a68a1aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports